import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import type { Options } from "@contentful/rich-text-react-renderer";
import { RichText } from "./types";

export type RichTextRendererProps = {
  richText?: RichText | null;
  options?: Options;
};

const RichTextRenderer = ({ richText, options }: RichTextRendererProps) => {
  return <>{documentToReactComponents(richText?.json, options)}</>;
};

export default RichTextRenderer;
